import { Injectable, signal } from '@angular/core';

import { WorkflowAutomation } from '@core/workflow-automations-types';

@Injectable()
export class AutomationCacheService {
  private readonly initialAutomationData = signal<WorkflowAutomation | null>(null);

  public setInitialAutomationData(automation: WorkflowAutomation | null): void {
    this.initialAutomationData.set(automation);
  }

  public getInitialAutomationData(): WorkflowAutomation | null {
    return this.initialAutomationData();
  }
}
